import React from "react";
import { GeoAltFill, TelephoneFill, Envelope, Playstation, Robot, Truck, MusicNote } from 'react-bootstrap-icons'

const Heading = () => {
    return <div className="cv__sidebar-heading">
        <h1>JACKIN GUYCHARD ORLANDO</h1>
        <p className="fw-bold font-monospace h4 mb-2">$ Développeur Web</p>
        <div className="cv__sidebar-heading_address">
            <div>
                <GeoAltFill size={25} />
                <span>Cameroun Douala, New-Bell Ngangue</span>
            </div>
            <div>
                <TelephoneFill size={25} />
                <span>+237 693642189</span>
            </div>
            <div>
                <Envelope size={25} />
                <span><a href="mailto:guichardorlando@gmail.com" >guichardorlando@gmail.com</a></span>
            </div>
        </div>
    </div>
}

const Leisure = () => {
    return <div className="cv__sidebar-leisure pt-5">
        <h4 className="mb-3">Centres D'intérêts & Loisirs</h4>

        <div className="cv__sidebar-leisure_content">
            <div>
                <Robot size={25} />
                <span>Intelligence Artificielle</span>
            </div>
            <div>
                <Playstation size={25} />
                <span>Jeux Vidéos</span>
            </div>
            <div>
                <MusicNote size={25} />
                <span>Musique</span>
            </div>
            <div>
                <Truck size={25} />
                <span>Voyage</span>
            </div>
        </div>
    </div>
}

const SideBar = ({ children }) => {
    return <div className="cv__sideBar container p-4">
        <Heading />
        {children}
        <Leisure />
    </div>
}

export default SideBar